import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './contact.css';
import './speedy-truck.css';
import { Footer } from '../footer/footer';
import { Action, Dispatch } from 'redux';
import { contactSetSubmissionInProcess, contactSubmitForm} from '../../store/contact/contact.actions';
import { AppState } from '../../store/model';
import { isSubmissionInProcess, isSubmissionFailed } from '../../store/contact/contact.selectors';
import { errorNotificationAdd } from '../../store/notification/notification.actions';

interface Props {

}

interface InternalState {
    firstName: string;
    lastName: string;
    message: string;
    phone: string;
    email: string;
}

interface ConnectedState {
    isSubmissionFailed: boolean;
    isSubmissionInProcess: boolean;
}

function mapStateToProps(state: AppState): ConnectedState {
    return {
        isSubmissionFailed: isSubmissionFailed(state),
        isSubmissionInProcess: isSubmissionInProcess(state),
    }
}

interface ConnectedDispatch {
    submitForm: (firstname: string, lastName: string, message: string, phone?: string, email?: string) => void;
    setSubmissionInProcess: (isSubmissionInProcess: boolean) => void;
    showErrorNotification: (message: string) => void;
}

const mapDispatchToProps = (dispatch: Dispatch<Action>): ConnectedDispatch => ({
    submitForm: (firstname, lastName, message, phone, email) =>
        dispatch(contactSubmitForm(firstname, lastName, message, phone, email)),
    setSubmissionInProcess: (s) => dispatch(contactSetSubmissionInProcess(s)),
    showErrorNotification: (message) => dispatch(errorNotificationAdd(message, {})),
});

class Contact extends React.PureComponent<Props & ConnectedState & ConnectedDispatch, InternalState> {


    constructor(props: Props & ConnectedState & ConnectedDispatch) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            message: ''
        }

        this.onFirstNameChange = this.onFirstNameChange.bind(this);
        this.onLastNameChange = this.onLastNameChange.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.onPhoneChange = this.onPhoneChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUnload = this.handleUnload.bind(this);
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.handleUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleUnload);
    }

    handleUnload(e) {
        var message = "\o/";

        (e || window.event).returnValue = message; //Gecko + IE
        return message;
    }

    onFirstNameChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({
            firstName: event.currentTarget.value
        });
    }

    onLastNameChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({
            lastName: event.currentTarget.value
        });
    }

    onMessageChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({
            message: event.currentTarget.value
        });
    }

    onPhoneChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({
            phone: event.currentTarget.value
        });
    }

    onEmailChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({
            email: event.currentTarget.value
        });
    }

    onSubmit() {

        this.props.setSubmissionInProcess(true);

        setTimeout(() => {

            if (this.state.firstName === '') {
                this.props.showErrorNotification('First name cannot be empty!');

                this.props.setSubmissionInProcess(false);
                return;
            }

            if (this.state.lastName === '') {
                this.props.showErrorNotification('Last name cannot be empty!');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.message === '') {
                this.props.showErrorNotification('Message cannot be empty!');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.firstName.length > 50) {
                this.props.showErrorNotification('First name is too long');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.lastName.length > 50) {
                this.props.showErrorNotification('Last name is too long');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.email.length > 50) {
                this.props.showErrorNotification('Email name is too long');
                this.props.setSubmissionInProcess(false);

                return;
            } else if (this.state.email.length < 5) {
                this.props.showErrorNotification('Email name is too short');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.phone.length > 50) {
                this.props.showErrorNotification('Phone name is too long');
                this.props.setSubmissionInProcess(false);

                return;
            } else if (this.state.phone.length > 1 && this.state.phone.length < 5) {
                this.props.showErrorNotification('Phone name is too short');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.message.length > 300) {
                this.props.showErrorNotification('Message name is too long');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.message.length < 50) {
                this.props.showErrorNotification('Message name is too short');
                this.props.setSubmissionInProcess(false);

                return;
            }

            if (this.state.email.length < 5 && !this.state.email.indexOf('@') && !this.state.email.indexOf('.')) {
                this.props.showErrorNotification('Invalid email address');
                this.props.setSubmissionInProcess(false);

                return;
            }

            this.props.submitForm(this.state.firstName, this.state.lastName, this.state.message, this.state.phone, this.state.email);

            this.props.setSubmissionInProcess(false);

            if (!this.props.isSubmissionFailed) {
                this.setState({
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    message: ''
                });
            }
        }, 500);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.onSubmit();
    }

    render() {
        return (
            <main>
                <div className={'contact-page'}>
                    <div className={'contact-container-holder'}>
                        <div className={'contact-container-image-hover'}>
                            <form className='contact-container' onSubmit={this.handleSubmit}>
                                <h1>&bull; <FormattedMessage id={'page.contact.title'} /> &bull;</h1>
                                <div className='underline'/>
                                <div className='icon_wrapper'>
                                    <svg className='icon' viewBox='0 0 145.192 145.192'>
                                        <path
d='M126.82,32.694c-2.804,0-5.08,2.273-5.08,5.075v2.721c-1.462,0-2.646,1.185-2.646,2.647v1.995    c0,1.585,1.286,2.873,2.874,2.873h20.577c1.462,0,2.646-1.185,2.646-2.647v-3.041c0-1.009-0.816-1.825-1.823-1.825v-2.722    c0-2.802-2.276-5.075-5.079-5.075h-1.985v-3.829c0-3.816-3.095-6.912-6.913-6.912h-0.589h-20.45c0-2.67-2.164-4.835-4.833-4.835    H56.843c-2.67,0-4.835,2.165-4.835,4.835H34.356v-3.384h-9.563v3.384v1.178h-7.061v1.416c-2.67,0.27-10.17,1.424-13.882,5.972    c-1.773,2.17-2.44,4.791-1.983,7.793c0.463,3.043,1.271,6.346,2.128,9.841c2.354,9.616,5.024,20.515,0.549,28.077    C2.647,79.44-3.125,90.589,2.201,99.547c4.123,6.935,13.701,10.44,28.5,10.44c1.186,0,2.405-0.023,3.658-0.068v9.028h-0.296    c-2.516,0-4.558,2.039-4.558,4.558v4.566h100.04v-4.564c0-2.519-2.039-4.558-4.558-4.558h-0.297V84.631h0.297    c2.519,0,4.558-2.037,4.558-4.556v-0.009c0-2.516-2.039-4.556-4.556-4.556l-36.786-0.009V61.973c0-2.193-1.777-3.971-3.972-3.971    v-4.711h0.456c1.629,0,2.952-1.32,2.952-2.949h14.227V34.459h1.658c2.672,0,4.834-2.165,4.834-4.834h20.45v3.069H126.82z     M34.06,75.511c-2.518,0-4.558,2.04-4.558,4.556v0.009c0,2.519,2.042,4.556,4.558,4.556h0.296v24.12l-0.042-1.168    c-15.994,0.574-26.122-2.523-30.106-9.229C-0.464,90.5,4.822,80.347,6.55,77.423c4.964-8.382,2.173-19.774-0.29-29.825    c-0.843-3.442-1.639-6.696-2.088-9.638c-0.354-2.35,0.129-4.3,1.484-5.958c3.029-3.714,9.509-4.805,12.076-5.1v1.233h7.061v1.49    v2.684c-2.403,1.114-4.153,2.997-4.676,5.237H18.15c-0.584,0-1.056,0.474-1.056,1.056v0.83c0,0.584,0.475,1.056,1.056,1.056h1.984    c0.561,2.18,2.304,3.999,4.658,5.092v0.029c0,0-2.282,20.823,16.479,22.099v1.102c0,1.177,0.955,2.133,2.133,2.133h3.297    c1.178,0,2.133-0.956,2.133-2.133V50.135c0-1.177-0.955-2.132-2.133-2.132h-3.297c-1.178,0-2.133,0.955-2.133,2.132    c-1.575-0.235-5.532-1.17-6.635-4.547c2.36-1.092,4.109-2.913,4.669-5.097h1.308c0.722,0,1.309-0.584,1.309-1.308v-0.578    c0-0.584-0.475-1.056-1.056-1.056h-1.539c-0.542-2.332-2.416-4.271-4.968-5.363v-2.559h17.651c0,2.67,2.166,4.835,4.836,4.835 h2.392v15.88h13.639c0,1.629,1.321,2.949,2.951,2.949h0.899v4.711c-2.194,0-3.972,1.778-3.972,3.971v13.529L34.06,75.511z     M95.188,101.78c0,8.655-7.012,15.665-15.664,15.665c-8.653,0-15.667-7.01-15.667-15.665c0-8.647,7.014-15.664,15.667-15.664    C88.177,86.116,95.188,93.132,95.188,101.78z M97.189,45.669h-9.556c0-0.896-0.726-1.62-1.619-1.62H74.494    c-0.896,0-1.621,0.727-1.621,1.62h-8.967v-11.21h33.283V45.669z'/>
                                        <path
d='M70.865,101.78c0,4.774,3.886,8.657,8.66,8.657c4.774,0,8.657-3.883,8.657-8.657c0-4.773-3.883-8.656-8.657-8.656    C74.751,93.124,70.865,97.006,70.865,101.78z'/>
                                    </svg>
                                </div>
                                <label htmlFor='fname'>
                                    <FormattedMessage id={'page.contact.firstName'} />
                                </label>
                                <input
                                    type='text'
                                    id='fname'
                                    name='firstname'
                                    placeholder='Your name..'
                                    onChange={this.onFirstNameChange}
                                    value={this.state.firstName}
                                    required
                                />

                                <label htmlFor='lname'>
                                    <FormattedMessage id={'page.contact.lastName'} />
                                </label>
                                <input
                                    type='text'
                                    id='lname'
                                    name='lastname'
                                    placeholder='Your last name..'
                                    onChange={this.onLastNameChange}
                                    value={this.state.lastName}
                                    required
                                />

                                <label htmlFor='phone'>
                                    <FormattedMessage id={'page.contact.phone'} />
                                </label>
                                <input
                                    type='text'
                                    id='phone'
                                    name='phone'
                                    placeholder='Your phone number..'
                                    onChange={this.onPhoneChange}
                                    value={this.state.phone}
                                />

                                <label htmlFor='email'>
                                    <FormattedMessage id={'page.contact.email'} />
                                </label>
                                <input
                                    type='email'
                                    id='email'
                                    name='email'
                                    placeholder='Your email..'
                                    onChange={this.onEmailChange}
                                    value={this.state.email}
                                />

                                <label htmlFor='message'>
                                    <FormattedMessage id={'page.contact.message'} />
                                </label>
                                <textarea
                                    id='message'
                                    name='subject'
                                    placeholder='Write something..'
                                    onChange={this.onMessageChange}
                                    value={this.state.message}
                                    required
                                />

                                <input
                                    type='submit'
                                    value='Submit'
                                />
                            </form>
                        </div>
                    </div>
                    <div id={'submission-loader'} className={this.props.isSubmissionInProcess ? 'show-loader' : 'hide-loader'}>
                        <div className='loop-wrapper'>
                            <div className='mountain'></div>
                            <div className='hill'></div>
                            <div className='tree'></div>
                            <div className='tree'></div>
                            <div className='tree'></div>
                            <div className='rock'></div>
                            <div className='truck'></div>
                            <div className='wheels'></div>
                        </div>
                    </div>
                    <div className='map-container'>
                        <iframe
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d156722.88508075214!2d-74.10983519491565!3d40.68967708996477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sde!4v1643400296185!5m2!1sen!2sde'
                            style={{border: 'o'}} allowFullScreen={false} loading='lazy'/>
                    </div>
                </div>
                <Footer/>
            </main>
        );
    }
}

export const ContactComponent = connect(mapStateToProps, mapDispatchToProps)(Contact);